///training-materials/get
export function getTrainingMaterials() {
    return {
        "ok": true,
        "data": [
            {
                "completionTracking": {
                    "enabled": false,
                    "requiredItems": 0
                },
                "stats": {
                    "totalViews": 14,
                    "totalCompletions": 0,
                    "averageRating": 0,
                    "totalRatings": 0
                },
                "category": "general",
                "difficulty": "beginner",
                "tags": [],
                "isActive": true,
                "isPublic": false,
                "requiredRoles": [],
                "version": 15,
                "_id": "6881ab46f532211550e1d7ce",
                "title": "dtesddas",
                "description": "dasdasd",
                "type": "video",
                "company": "Sparkle Star International - Inhouse",
                "urls": [
                    {
                        "fileType": "video",
                        "order": 0,
                        "_id": "6881ab46f532211550e1d7cf",
                        "title": "sdasd",
                        "url": "https://www.youtube.com/watch?v=krt_TWyBA2E&ab_channel=LudietHistoria",
                        "createdAt": "2025-07-24T03:40:54.390Z",
                        "updatedAt": "2025-07-24T03:40:54.390Z"
                    }
                ],
                "createdBy": {
                    "firstName": "Sparkle",
                    "lastName": "Star",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "_id": "64f15182dbd477002ddc95bf"
                },
                "files": [],
                "createdAt": "2025-07-24T03:40:54.390Z",
                "updatedAt": "2025-09-29T06:42:00.535Z",
                "estimatedDuration": 5,
                "__v": 0,
                "totalItems": 1,
                "formattedCreatedAt": "7/24/2025",
                "id": "6881ab46f532211550e1d7ce"
            },
            {
                "completionTracking": {
                    "enabled": false,
                    "requiredItems": 0
                },
                "stats": {
                    "totalViews": 22,
                    "totalCompletions": 0,
                    "averageRating": 0,
                    "totalRatings": 0
                },
                "category": "general",
                "difficulty": "beginner",
                "tags": [],
                "isActive": true,
                "isPublic": false,
                "requiredRoles": [],
                "version": 23,
                "_id": "6881aaa1f532211550e1d7ad",
                "title": "tese3232",
                "description": "dwdawd",
                "type": "video",
                "company": "Sparkle Star International - Inhouse",
                "urls": [
                    {
                        "fileType": "video",
                        "order": 0,
                        "_id": "6881aaa1f532211550e1d7ae",
                        "title": "wdwd",
                        "url": "https://www.youtube.com/watch?v=jGQhD-gAo9A&ab_channel=CombatVeteranReacts",
                        "createdAt": "2025-07-24T03:38:09.551Z",
                        "updatedAt": "2025-07-24T03:38:09.551Z"
                    }
                ],
                "createdBy": {
                    "firstName": "Sparkle",
                    "lastName": "Star",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "_id": "64f15182dbd477002ddc95bf"
                },
                "files": [],
                "createdAt": "2025-07-24T03:38:09.551Z",
                "updatedAt": "2025-09-29T06:42:02.600Z",
                "estimatedDuration": 5,
                "__v": 0,
                "totalItems": 1,
                "formattedCreatedAt": "7/24/2025",
                "id": "6881aaa1f532211550e1d7ad"
            },
            {
                "completionTracking": {
                    "enabled": false,
                    "requiredItems": 0
                },
                "stats": {
                    "totalViews": 19,
                    "totalCompletions": 0,
                    "averageRating": 0,
                    "totalRatings": 0
                },
                "category": "general",
                "difficulty": "beginner",
                "tags": [],
                "isActive": true,
                "isPublic": false,
                "requiredRoles": [],
                "version": 20,
                "_id": "6880f207f532211550e1d5c8",
                "title": "test232",
                "description": "test",
                "type": "video",
                "company": "Sparkle Star International - Inhouse",
                "createdBy": {
                    "firstName": "Sparkle",
                    "lastName": "Star",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "_id": "64f15182dbd477002ddc95bf"
                },
                "urls": [
                    {
                        "fileType": "video",
                        "order": 0,
                        "_id": "68819eb4f532211550e1d6c8",
                        "title": "test",
                        "url": "https://www.youtube.com/watch?v=Y-Oin4KDHH8&ab_channel=AsmongoldTV",
                        "updatedAt": "2025-07-24T02:47:44.926Z",
                        "createdAt": "2025-07-24T02:47:44.926Z"
                    },
                    {
                        "fileType": "video",
                        "order": 1,
                        "_id": "68819ed0f532211550e1d6d6",
                        "title": "test2",
                        "url": "https://www.youtube.com/watch?v=eoqpXbe8dyA&ab_channel=Theo-t3%E2%80%A4gg",
                        "updatedAt": "2025-07-24T02:47:44.926Z",
                        "createdAt": "2025-07-24T02:47:44.926Z"
                    }
                ],
                "files": [],
                "createdAt": "2025-07-23T14:30:31.458Z",
                "updatedAt": "2025-09-29T06:42:04.066Z",
                "__v": 0,
                "updatedBy": {
                    "firstName": "Sparkle",
                    "lastName": "Star",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "_id": "64f15182dbd477002ddc95bf"
                },
                "estimatedDuration": 10,
                "totalItems": 2,
                "formattedCreatedAt": "7/23/2025",
                "id": "6880f207f532211550e1d5c8"
            },
            {
                "completionTracking": {
                    "enabled": false,
                    "requiredItems": 0
                },
                "stats": {
                    "totalViews": 4,
                    "totalCompletions": 0,
                    "averageRating": 0,
                    "totalRatings": 0
                },
                "category": "general",
                "difficulty": "beginner",
                "tags": [
                    "test"
                ],
                "isActive": true,
                "isPublic": true,
                "requiredRoles": [],
                "version": 5,
                "_id": "6870e25846ae3271c8d9aa8a",
                "title": "test",
                "description": "test",
                "type": "module",
                "company": "Sparkle Star International - Inhouse",
                "files": [
                    {
                        "fileType": "doc",
                        "order": 0,
                        "_id": "6870e25846ae3271c8d9aa8b",
                        "title": "test",
                        "url": "https://drive.google.com/file/d/0BxQpJntkO9GSZUVQWXUwT3N3Sjg/view?usp=drive_link&resourcekey=0-TuNvl4f3dv4b4Zc7a28GjA",
                        "createdAt": "2025-07-11T10:07:20.453Z",
                        "updatedAt": "2025-07-11T10:07:20.453Z"
                    }
                ],
                "createdBy": {
                    "firstName": "Sparkle",
                    "lastName": "Star",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "_id": "64f15182dbd477002ddc95bf"
                },
                "urls": [],
                "createdAt": "2025-07-11T10:07:20.453Z",
                "updatedAt": "2025-09-26T03:34:00.292Z",
                "estimatedDuration": 2,
                "__v": 0,
                "totalItems": 1,
                "formattedCreatedAt": "7/11/2025",
                "id": "6870e25846ae3271c8d9aa8a"
            },
            {
                "completionTracking": {
                    "enabled": false,
                    "requiredItems": 0
                },
                "stats": {
                    "totalViews": 16,
                    "totalCompletions": 0,
                    "averageRating": 0,
                    "totalRatings": 0
                },
                "category": "general",
                "difficulty": "intermediate",
                "tags": [
                    "test"
                ],
                "isActive": true,
                "isPublic": false,
                "requiredRoles": [],
                "version": 17,
                "_id": "6870e23346ae3271c8d9aa81",
                "title": "test",
                "description": "test",
                "type": "video",
                "company": "Sparkle Star International - Inhouse",
                "urls": [
                    {
                        "fileType": "video",
                        "order": 0,
                        "_id": "6870e23346ae3271c8d9aa82",
                        "title": "test",
                        "url": "https://www.youtube.com/watch?v=21HSmydkxaE&ab_channel=AntonPetrov",
                        "createdAt": "2025-07-11T10:06:43.468Z",
                        "updatedAt": "2025-07-11T10:06:43.468Z"
                    }
                ],
                "createdBy": {
                    "firstName": "Sparkle",
                    "lastName": "Star",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "_id": "64f15182dbd477002ddc95bf"
                },
                "files": [],
                "createdAt": "2025-07-11T10:06:43.468Z",
                "updatedAt": "2025-09-29T06:41:41.968Z",
                "estimatedDuration": 5,
                "__v": 0,
                "totalItems": 1,
                "formattedCreatedAt": "7/11/2025",
                "id": "6870e23346ae3271c8d9aa81"
            }
        ],
        "count": 5
    }
}


//training-materials/create
//post
export function createTrainingMaterial() {
    return {
        "ok": true,
        "message": "Training material created successfully",
        "data": {
            "completionTracking": {
                "enabled": false,
                "requiredItems": 0
            },
            "stats": {
                "totalViews": 0,
                "totalCompletions": 0,
                "averageRating": 0,
                "totalRatings": 0
            },
            "category": "general",
            "difficulty": "beginner",
            "tags": [],
            "isActive": true,
            "isPublic": false,
            "requiredRoles": [],
            "version": 1,
            "_id": "69f9447c4c686578dccaaa30",
            "title": "123123",
            "description": "123123123",
            "type": "video",
            "company": "Sparkle Star International - Inhouse",
            "createdBy": {
                "firstName": "Jeffrey",
                "lastName": "Pareja",
                "email": "jeffreypareja25@gmail.com",
                "_id": "61442a17a6566a001623bf20"
            },
            "urls": [],
            "files": [],
            "createdAt": "2026-05-05T01:14:37.035Z",
            "updatedAt": "2026-05-05T01:14:37.035Z",
            "__v": 0,
            "totalItems": 0,
            "formattedCreatedAt": "5/5/2026",
            "id": "69f9447c4c686578dccaaa30"
        }
    }
}